import React from 'react';

import { useEffect } from 'react';

import { useNavigate, Form } from 'react-router-dom';

import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

import { FormGroup } from 'react-bootstrap';
import { FormLabel } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

import AuthorStore from '../../../stores/AuthorStore';

const AuthorCreatePage = ({ users }) => {
    const navigate = useNavigate();

    const store = AuthorStore((state) => state);

    useEffect(() => {
        store.resetAuthor();
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    return (
        <Container style={{ marginTop: '10px', width: '100%' }}>
            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <Button
                        onClick={() => {
                            navigate('/author');
                        }}
                    >
                        Back to list
                    </Button>

                    <div>Author Creation Page</div>

                    <br />

                    <Form method="post" action="/author/backend/create">
                        <FormGroup>
                            <FormLabel>
                                First Name<span className="text-danger">*</span>
                            </FormLabel>
                            <FormControl
                                name="firstName"
                                type="text"
                                onChange={(e) => {
                                    store.updateAttribute(
                                        'firstName',
                                        e.target.value,
                                    );
                                }}
                            />
                        </FormGroup>

                        <FormGroup>
                            <FormLabel>
                                Last Name<span className="text-danger">*</span>
                            </FormLabel>
                            <FormControl
                                name="lastName"
                                type="text"
                                onChange={(e) => {
                                    store.updateAttribute(
                                        'lastName',
                                        e.target.value,
                                    );
                                }}
                            />
                        </FormGroup>

                        <br />
                        <br />

                        <Button
                            onClick={() => {
                                store.create(
                                    store.author,
                                    () => {
                                        alert('Your author was saved');
                                        navigate('/author');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Create
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                navigate('/author');
                            }}
                        >
                            Cancel
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default AuthorCreatePage;
